export var ApplicationSectionStatus;
(function (ApplicationSectionStatus) {
    ApplicationSectionStatus[ApplicationSectionStatus["Complete"] = 1] = "Complete";
    ApplicationSectionStatus[ApplicationSectionStatus["Partial"] = 2] = "Partial";
    ApplicationSectionStatus[ApplicationSectionStatus["MissingRequired"] = 3] = "MissingRequired";
    ApplicationSectionStatus[ApplicationSectionStatus["NoData"] = 4] = "NoData";
    ApplicationSectionStatus[ApplicationSectionStatus["NotApplicable"] = 5] = "NotApplicable";
})(ApplicationSectionStatus || (ApplicationSectionStatus = {}));
export var ApplicationFormStatus;
(function (ApplicationFormStatus) {
    ApplicationFormStatus[ApplicationFormStatus["NoStatus"] = 0] = "NoStatus";
    ApplicationFormStatus[ApplicationFormStatus["Active"] = 1] = "Active";
    ApplicationFormStatus[ApplicationFormStatus["Completed"] = 2] = "Completed";
    ApplicationFormStatus[ApplicationFormStatus["Closed"] = 3] = "Closed";
    ApplicationFormStatus[ApplicationFormStatus["Pending"] = 4] = "Pending";
    ApplicationFormStatus[ApplicationFormStatus["Declined"] = 5] = "Declined";
    ApplicationFormStatus[ApplicationFormStatus["Submitted"] = 6] = "Submitted";
    ApplicationFormStatus[ApplicationFormStatus["Referred"] = 7] = "Referred";
    ApplicationFormStatus[ApplicationFormStatus["Returned"] = 8] = "Returned";
    ApplicationFormStatus[ApplicationFormStatus["Sent"] = 9] = "Sent";
    ApplicationFormStatus[ApplicationFormStatus["Pass"] = 10] = "Pass";
    ApplicationFormStatus[ApplicationFormStatus["Ready"] = 11] = "Ready";
    ApplicationFormStatus[ApplicationFormStatus["Transferred"] = 12] = "Transferred";
    ApplicationFormStatus[ApplicationFormStatus["Completion"] = 13] = "Completion";
    ApplicationFormStatus[ApplicationFormStatus["AutoDeclined"] = 14] = "AutoDeclined";
    ApplicationFormStatus[ApplicationFormStatus["ReferredWaitingForMoreInfo"] = 15] = "ReferredWaitingForMoreInfo";
    ApplicationFormStatus[ApplicationFormStatus["DeclinedWaitingForMoreInfo"] = 16] = "DeclinedWaitingForMoreInfo";
    ApplicationFormStatus[ApplicationFormStatus["AutoDeclinedWaitingForMoreInfo"] = 17] = "AutoDeclinedWaitingForMoreInfo";
    ApplicationFormStatus[ApplicationFormStatus["ReferredWithMoreInfoSubmited"] = 18] = "ReferredWithMoreInfoSubmited";
    ApplicationFormStatus[ApplicationFormStatus["DeclinedWithMoreInfoSubmited"] = 19] = "DeclinedWithMoreInfoSubmited";
    ApplicationFormStatus[ApplicationFormStatus["AutoDeclinedWithMoreInfoSubmited"] = 20] = "AutoDeclinedWithMoreInfoSubmited";
    ApplicationFormStatus[ApplicationFormStatus["AutoRefer"] = 21] = "AutoRefer";
    ApplicationFormStatus[ApplicationFormStatus["AutoDeclineCancelled"] = 22] = "AutoDeclineCancelled";
    ApplicationFormStatus[ApplicationFormStatus["CallValidateCallCreditRefer"] = 23] = "CallValidateCallCreditRefer";
    ApplicationFormStatus[ApplicationFormStatus["CallValidateCallCreditFail"] = 24] = "CallValidateCallCreditFail";
})(ApplicationFormStatus || (ApplicationFormStatus = {}));
export var FormType;
(function (FormType) {
    FormType[FormType["Application"] = 1] = "Application";
    FormType[FormType["DIP"] = 2] = "DIP";
    FormType[FormType["Illustration"] = 3] = "Illustration";
    FormType[FormType["Enquiry"] = 4] = "Enquiry";
})(FormType || (FormType = {}));
export var ApplicationStatus;
(function (ApplicationStatus) {
    ApplicationStatus[ApplicationStatus["NoStatus"] = 0] = "NoStatus";
    ApplicationStatus[ApplicationStatus["Active"] = 1] = "Active";
    ApplicationStatus[ApplicationStatus["Completed"] = 2] = "Completed";
    ApplicationStatus[ApplicationStatus["Closed"] = 3] = "Closed";
    ApplicationStatus[ApplicationStatus["Pending"] = 4] = "Pending";
    ApplicationStatus[ApplicationStatus["Declined"] = 5] = "Declined";
    ApplicationStatus[ApplicationStatus["Submitted"] = 6] = "Submitted";
    ApplicationStatus[ApplicationStatus["Referred"] = 7] = "Referred";
    ApplicationStatus[ApplicationStatus["Returned"] = 8] = "Returned";
    ApplicationStatus[ApplicationStatus["Sent"] = 9] = "Sent";
    ApplicationStatus[ApplicationStatus["Pass"] = 10] = "Pass";
    ApplicationStatus[ApplicationStatus["Ready"] = 11] = "Ready";
    ApplicationStatus[ApplicationStatus["Transferred"] = 12] = "Transferred";
    ApplicationStatus[ApplicationStatus["Completion"] = 13] = "Completion";
    ApplicationStatus[ApplicationStatus["AutoDeclined"] = 14] = "AutoDeclined";
    ApplicationStatus[ApplicationStatus["ReferredWaitingForMoreInfo"] = 15] = "ReferredWaitingForMoreInfo";
    ApplicationStatus[ApplicationStatus["DeclinedWaitingForMoreInfo"] = 16] = "DeclinedWaitingForMoreInfo";
    ApplicationStatus[ApplicationStatus["AutoDeclinedWaitingForMoreInfo"] = 17] = "AutoDeclinedWaitingForMoreInfo";
    ApplicationStatus[ApplicationStatus["ReferredWithMoreInfoSubmited"] = 18] = "ReferredWithMoreInfoSubmited";
    ApplicationStatus[ApplicationStatus["DeclinedWithMoreInfoSubmited"] = 19] = "DeclinedWithMoreInfoSubmited";
    ApplicationStatus[ApplicationStatus["AutoDeclinedWithMoreInfoSubmited"] = 20] = "AutoDeclinedWithMoreInfoSubmited";
    ApplicationStatus[ApplicationStatus["AutoRefer"] = 21] = "AutoRefer";
    ApplicationStatus[ApplicationStatus["AutoDeclineCancelled"] = 22] = "AutoDeclineCancelled";
    ApplicationStatus[ApplicationStatus["CallValidateCallCreditRefer"] = 23] = "CallValidateCallCreditRefer";
    ApplicationStatus[ApplicationStatus["CallValidateCallCreditFail"] = 24] = "CallValidateCallCreditFail";
})(ApplicationStatus || (ApplicationStatus = {}));
export var BrokerStatus;
(function (BrokerStatus) {
    BrokerStatus[BrokerStatus["Active"] = 1] = "Active";
    BrokerStatus[BrokerStatus["Suspended"] = 2] = "Suspended";
    BrokerStatus[BrokerStatus["Deleted"] = 3] = "Deleted";
    BrokerStatus[BrokerStatus["Pending"] = 4] = "Pending";
    BrokerStatus[BrokerStatus["Inactive"] = 5] = "Inactive";
    BrokerStatus[BrokerStatus["SuperUser"] = 9] = "SuperUser";
})(BrokerStatus || (BrokerStatus = {}));
export var OrganisationStatus;
(function (OrganisationStatus) {
    OrganisationStatus[OrganisationStatus["Active"] = 1] = "Active";
    OrganisationStatus[OrganisationStatus["Suspended"] = 2] = "Suspended";
    OrganisationStatus[OrganisationStatus["Deleted"] = 3] = "Deleted";
    OrganisationStatus[OrganisationStatus["Pending"] = 4] = "Pending";
    OrganisationStatus[OrganisationStatus["Inactive"] = 5] = "Inactive";
})(OrganisationStatus || (OrganisationStatus = {}));
